import React, { useState, useEffect, useCallback, useRef } from "react";
import Select from "react-select";
import { GetServiceCaller, PostServiceCaller } from "../../../../../services/serviceCaller";
import * as Yup from "yup";
import { API_URL } from "../../../../../constants";
import { toast, ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";

const CategoryDesignationForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("PR Category Question Weightage Master"));
  }, []);

  console.log("✅ CategoryDesignationForm mounted");
  const [formData, setFormData] = useState([
    {
      CategoryID: "",
      QuestionsID: "",
      line: [],
    },
  ]);

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [designationNameOption, setDesignationNameOption] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [questionOptions, setQuestionOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const [editData, setEditData] = useState(null);
  const categoryId = params.get("categoryId");
  const questionId = params.get("questionId");
  // const questionId = params.get("questionId");
  const isEditMode = Boolean(categoryId && questionId);


  useEffect(() => {
    if (categoryId && questionId) {
      fetchEditData();
    }
  }, [categoryId, questionId]);



  // ------------------- YUP VALIDATION -------------------
  const schema = Yup.object().shape({
    CategoryID: Yup.string().required("Category is required"),
    QuestionsID: Yup.string().required("Questions field is required"),
    line: Yup.array()
      .min(1, "At least one designation is required")
      .of(
        Yup.object().shape({
          Weightage: Yup.number()
            .typeError("Weightage must be a number")
            .required("Weightage is required"),
          Experience: Yup.string().required("Experience is required"),
        })
      ),
  });

  // ------------------- GET API -------------------
  const fetchGetApi = useCallback(async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}pr-category`);
      if (response?.status === 200) {
        const data = response.data;

        setCategoryOptions(
          Array.isArray(data?.mappingCategory)
            ? data.mappingCategory.map(el => ({ value: el.value, label: el.text }))
            : []
        );

         setDesignationNameOption(
          Array.isArray(data?.DesignationName)
            ? data.DesignationName.map(el => ({ label: el.Name }))
            : []
        );

        setDesignationOptions(
          Array.isArray(data?.category)
            ? data.category.map(el => ({ value: el.value, label: el.text }))
            : []
        );

        setQuestionOptions(
          Array.isArray(data?.activequestion)
            ? data.activequestion.map(el => ({ value: el.ID, label: el.Name }))
            : []
        );

      }
    } catch (error) {
      console.error("❌ Error fetching:", error);
    }
  }, []);

  useEffect(() => {
    fetchGetApi();
  }, [fetchGetApi]);





  //---------------------Show API Code--------------------
  const loadQuestions = async (categoryId) => {
    try {
      const res = await GetServiceCaller(`${API_URL}get-category-question/${categoryId}`);
      const formattedQuestions = res.data.categoryquestion.map(q => ({
        value: Number(q.ID),
        label: q.Title
      }));
      setQuestionOptions(formattedQuestions);
    } catch (err) {
      console.error(err);
      setQuestionOptions([]);
    }
  };

  console.log("🌍 window.location.search =", window.location.search);
  const fetchEditData = async () => {
    console.log("🔥 fetchEditData called", { categoryId, questionId });
    if (!categoryId || !questionId) return;
    setPageLoading(true); 
    try {
      const res = await GetServiceCaller(
        `${API_URL}show-category-data/${categoryId}/${questionId}`
      );

      if (res.status === 200) {
        const data = res.data;

        setFormData([
          {
            CategoryID: Number(data.CategoryID),
            QuestionsID: Number(data.QuestionID),
            line: data.line.map((row) => ({
              GroupID: Number(row.GroupID),      // ✅ convert to number
              Weightage: Number(row.Weightage),  // ✅ convert to number
              GroupName: row.GroupName           // optional
            })),
          },
        ]);

        await loadQuestions(data.CategoryID);
      }
    } catch (err) {
      toast.error("Failed to load edit data");
    }
    finally {
    setPageLoading(false); 
  }
  };
  // ------------------- HANDLE CHANGES -------------------
  const handleCategoryChange = async (selected) => {
    // 1️⃣ Update CategoryID & reset QuestionsID
    setFormData([
      {
        ...formData[0],
        CategoryID: selected?.value || "",
        QuestionsID: ""
      }
    ]);

    // 2️⃣ If cleared, reset questions
    if (!selected) {
      setQuestionOptions([]);
      return;
    }

    try {
      //Call API
      const res = await GetServiceCaller(`${API_URL}get-category-question/${selected.value}`);

      //Format for react-select
      const formattedQuestions = res.data?.categoryquestion.map((q) => ({
        value: q.ID,
        label: q.Title
      }));
      console.log("formatedQuestion", formattedQuestions);


      setQuestionOptions(formattedQuestions);
    } catch (error) {
      console.error("Error fetching questions", error);
      setQuestionOptions([]);
    }
  };



  const handleQuestionsChange = (selected) => {
    setFormData([{ ...formData[0], QuestionsID: selected?.value || "" }]);
  };

  useEffect(() => {
    if (!isEditMode && designationOptions.length > 0) {
      setFormData((prev) => [
        {
          ...prev[0],
          line: designationOptions.map((item) => ({
            GroupID: item.value,
            Weightage: 100,
            Experience: "0-2",
          })),
        },
      ]);
    }
  }, [designationOptions, isEditMode]);


  const updateLineField = (index, field, value) => {
    setFormData((prev) => {
      const updatedLine = [...prev[0].line];
      updatedLine[index] = { ...updatedLine[index], [field]: value };
      return [{ ...prev[0], line: updatedLine }];
    });
  };

  // ------------------- SUBMIT -------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = formData[0];

    const url = isEditMode
      ? `${API_URL}update-category-data/${payload.CategoryID}/${payload.QuestionsID}`
      : `${API_URL}pr-category`;

    const method = isEditMode ? "put" : "post";

    try {
      setLoading(true);
      const res = await PostServiceCaller(url, payload, method);

      if (res.status === 200) {
        toast.success(isEditMode ? "Updated successfully" : "Saved successfully");
        navigate("/category-designation");
      }
    } catch (err) {
      toast.error("Submission failed");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="container mt-4">
      <div className="card shadow p-4">
        <form onSubmit={handleSubmit} style={{ padding: "10px" }}>
          {/* QUESTIONS + CATEGORY */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "15px" }}>
            <div style={{ flex: 1 }}>
              <label className="fw-bold">Category</label>
              <Select
                options={categoryOptions}
                placeholder="Select Category"
                value={categoryOptions.find(
                  (x) => x.value === formData[0].CategoryID
                )}
                onChange={handleCategoryChange}
                isClearable
                isDisabled={isEditMode}
              />
            </div>
            <div style={{ flex: 1.4 }}>
              <label className="fw-bold">Questions</label>
              <Select
                options={questionOptions}
                placeholder="Select Questions"
                value={
                  questionOptions.find(
                    q => q.value === Number(formData[0]?.QuestionsID)
                  ) || null
                }
                onChange={handleQuestionsChange}
                isClearable
                isDisabled={isEditMode}
              // isDisabled={!formData[0].QuestionsID}
              // onChange={handleQuestionsChange}
              // isClearable
              />
            </div>
          </div>

          {/* DESIGNATIONS
          <div style={{ marginBottom: "15px" }}>
            <label className="fw-bold">Groups</label>
            <Select
            options={designationOptions}
            value={designationOptions}
            placeholder="Select Designations"
            isMulti
            isDisabled
          />
          </div> */}

          {/* TABLE */}
          {formData[0].line.length > 0 && (
            <table className="table table-bordered mt-3 text-center">
              <tbody>
                {/* Group Row */}
                <tr id="thcolor" className="table-light">
                  <th>Group</th>
                  
                  {formData[0].line.map((row, index) => (
                    
                    <td
                    key={index}
                    
                    className="tooltip-cell"
                    style={{ cursor: "pointer", fontWeight: "bold"}}
                  >
                    {
                      designationOptions.find(
                        (d) => d.value === row.GroupID
                      )?.label
                    }

                    <span className="custom-tooltip">
                      {designationNameOption?.[index]?.label || ""}
                    </span>
                  </td>

                  ))}
                </tr>

                {/* Weightage Row */}
                <tr>
                  <th>Weightage</th>
                  {formData[0].line.map((row, index) => (
                    <td key={index}>
                      <input
                        type="text"
                        className="form-control text-center"
                        value={row.Weightage}
                        onChange={(e) =>
                          updateLineField(index, "Weightage", e.target.value)
                        }
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          )}

          {/* SUBMIT BUTTON */}
          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <button
              type="submit"
              className="custom-btn"
              disabled={loading}
              style={{ padding: "8px 20px" }}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryDesignationForm;
